import ViewUiEditorHome from "../views/ViewUiEditorHome.vue"
import ViewUiEditorThemeEditor from "../views/ViewUiEditorThemeEditor"

export default [
	{
		path: "/ui-editor/:appId",
		component: ViewUiEditorHome,
		name: "ViewUiEditorHome",
		props: true,
		meta: {}
	},
	{
		path: "/ui-editor/theme/:appId",
		component: ViewUiEditorThemeEditor,
		name: "ViewUiEditorThemeEditor",
		meta: {}
	}
]
